import type { AxiosResponse } from 'axios';
import axios from 'axios';
import i18n from 'i18n';
import Cookies from 'js-cookie';

const fingerprintApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_BASE_URL_FINGERPRINT}`,
  headers: {
    Authorization: `Bearer ${Cookies.get('session_id')}`,
    'Content-Type': 'application/json',
  },
  timeout: 10_000,
});

fingerprintApi.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers['Language'] = i18n.language;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

const responseBody = <T>(response: AxiosResponse<{ result: T }>) => response.data?.result;

export const fingerprintApiExtract = {
  delete: <T>(url: string): Promise<T | undefined> => fingerprintApi.delete<{ result: T }>(url).then(responseBody),

  get: <T>(url: string): Promise<T | undefined> => fingerprintApi.get<{ result: T }>(url).then(responseBody),

  post: <T, B>(url: string, body?: B): Promise<T | undefined> =>
    fingerprintApi.post<{ result: T }>(url, body).then(responseBody),

  put: <T, B>(url: string, body?: B): Promise<T | undefined> =>
    fingerprintApi.put<{ result: T }>(url, body).then(responseBody),
};

export default fingerprintApi;
